module.exports = __webpack_public_path__ + "static/ziggy_hb-c8c856eccd20a05bfdeb8b7b144e0f0f.png";